import React, { useState } from 'react';
import { XIcon, YellowWarningIcon } from 'assests/GmsIcons';
import GMSBorderlessButton from 'Components/Common/components/GMSBorderlessButton';
import GMSFillButton from 'Components/Common/components/GMSFillButton';


type ConfirmDialogProps = {
    title: string;
    message: string;
    confirmText: string;
    cancelText: string;
    ternaryText: string;
    onClose: () => void;
    onConfirm: () => void;
    ternaryMethod: () => void;
}

const DecommitConfirmModal = ({ onClose, onConfirm }: ConfirmDialogProps) => {

    return (
        <div className={` tw-fixed tw-inset-0 tw-flex tw-items-center tw-justify-center tw-bg-gray-800 tw-bg-opacity-50 tw-z-50`}>
            <div className={`tw-bg-white tw-rounded tw-shadow-md tw-w-[378px]  tw-h-auto tw-py-2`}>
                <div className='tw-flex tw-justify-between tw-items-center'>
                    <h2 className={`tw-text-sm tw-font-semibold tw-my-3 tw-px-3 `}>Confirm Decommit</h2>
                    <button className='tw-mr-2' onClick={onClose}><XIcon /></button>
                </div>
                <div className="tw-w-[378px] tw-h-[0px] tw-border tw-border-[#dfe0e6]"></div>
                <div className="tw-w-[346px] tw-ml-5 tw-mt-2 tw-text-[#172b4d] tw-text-sm tw-font-medium tw-font-['Noto_Sans'] tw-leading-tight">
                    Are you sure you want to decommit this compatibility rule?
                </div>

                <div className="tw-h-auto tw-m-4 tw-p-2.5 tw-bg-[#fffae6] tw-rounded tw-border tw-border-[#ffc400] tw-justify-start tw-items-center tw-gap-2.5 tw-inline-flex">
                    <YellowWarningIcon />
                    <div className="tw-w-[292px]">
                        <span className="tw-text-black tw-text-sm tw-font-medium tw-font-['Noto_Sans'] tw-leading-tight">
                            Decommitting will<br />
                        </span>
                        <span className="tw-text-black tw-ml-2 tw-text-sm tw-font-normal tw-font-['Noto_Sans'] tw-leading-tight">
                            * Remove the rule from active use<br />
                        </span>
                        <span className="tw-text-black tw-ml-2 tw-text-sm tw-font-normal tw-font-['Noto_Sans'] tw-leading-tight">
                            * Clear all edge counts
                        </span>
                    </div>
                </div>
                <div className={`tw-px-3 tw-mt-6 tw-flex tw-gap-2 tw-justify-end`}>
                    <button onClick={onClose} className='button-outlined hover:tw-bg-gray-100'>Cancel</button>
                    <button className="tw-h-auto tw-w-auto tw-px-4 tw-py-2 tw-justify-center tw-items-center tw-gap-2.5  tw-rounded-md tw-inline-flex tw-text-white hover:tw-bg-[#d24724] tw-bg-[#bf2600]"
                        onClick={onConfirm}>
                        Decommit
                    </button>
                </div>
            </div>
        </div>
    );
}

export default DecommitConfirmModal;